import { render } from "./NewsList.vue?vue&type=template&id=d5eedcd6&scoped=true&ts=true"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"

import "./NewsList.vue?vue&type=style&index=0&id=d5eedcd6&lang=scss&scoped=true"
import "./NewsList.vue?vue&type=style&index=1&id=d5eedcd6&lang=scss"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5eedcd6"]])

export default __exports__